// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rXTIBz4vhxfwtoH4vEA2 {
  color: #FADB14;
  flex-shrink: 0;
  margin-left: 0.25rem;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stars": `rXTIBz4vhxfwtoH4vEA2`
};
export default ___CSS_LOADER_EXPORT___;
